module.exports = __webpack_public_path__ + "img/hombre.df7967fe.svg";